import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./components/Auth/Login";
import ForgetPassword from "./components/Auth/ForgetPassword";
import ResetLink from "./components/Auth/ResetLink";
import {
  LOGIN,
  FORGOT_PASSWORD,
  RESET_LINK,
  DASHBOARD,
  MANAGE_INSPECTOR,
  MANAGE_PROJECT,
  NOTIFICATION,
  ADD_INSPECTOR,
  VIEW_INSPECTOR_DETAILS,
  EDIT_INSPECTOR_DETAILS,
  ADD_PROJECT,
  VIEW_MANAGE_PROJECT_DETAILS,
  EDIT_MANAGE_PROJECT_DETAILS,
  CHANGE_PASSWORD,
  ADMIN_PROFILE,
  ADD_NEW_INSPECTION,
  WELDING_GAS_INSPECTION_FORM,
  WELDING_MACHINE_CALIBRATION,
  WELDING_WPQ_INSPECTION,
  ISO_WELD_LOG,
  PROJECT_REPORT,
  DESCRIPTION_MASTER,
  SIZE_MASTER,
  ENDS_MASTER,
  TYPE_MASTER,
  SURFACE_MASTER,
  WELDING_MASTER,
  INSPECTION_LOC_MASTER,
  MANUFACTURER_MASTER,
  ADD_MANUFACTURER_MASTER,
  ADD_INSPECTION_LOC_MASTER,
  ADD_WELDING_MASTER,
  ADD_SURFACE_MASTER,
  ADD_TYPE_MASTER,
  ADD_ENDS_MASTER,
  ADD_SIZE_MASTER,
  ADD_DESCRIPTION_MASTER,
  NCR_REPORT,
  DATA_VERIFICATION,
  GLOBAL_SEARCH,
} from "./components/utils/RouteConstant";
import Dashboard from "./components/Home/DashBoard/Dashboard";
import PublicRoutes from "./components/ScopeRoute/PulicRoute";
import ProtectedRoutes from "./components/ScopeRoute/ProtectedRoute";
import ManageInspector from "./components/Home/ManageInspectpor/ManageInspector";
import ManageProject from "./components/Home/ManageProject/ManageProject";
import Notification from "./components/Home/Notification/Notification";
import MainLayout from "./components/customComponent/MainLayout";
import AddInspector from "./components/Home/ManageInspectpor/AddInspector";
import ViewInspectorDetails from "./components/Home/ManageInspectpor/ViewInspectorDetails";
import EditInspector from "./components/Home/ManageInspectpor/EditInspector";
import AddProject from "./components/Home/ManageProject/AddProject";
import ViewManageProjectDetails from "./components/Home/ManageProject/ViewManageProjectDetails";
import EditManageProject from "./components/Home/ManageProject/EditManageProject";
import PageNotFoud from "./components/customComponent/PageNotFound/PageNotFoud";
import ChangePassword from "./components/Auth/ChangePassword";
import AdminProfile from "./components/customComponent/SideBar/AdminProfile";
import ViewDetailsNewInspection from "./components/Home/ManageProject/AddNewInspection/ViewDetailsNewInspection";
import ViewDetailsWeldingGas from "./components/Home/ManageProject/AddNewInspection/ViewDetailsWeldingGas";
import ViewDetailsWeldMachineCalibration from "./components/Home/ManageProject/AddNewInspection/ViewDetaisWeldMachineCalibration";
import ViewDetailsWeldingWPQ from "./components/Home/ManageProject/AddNewInspection/ViewDetailsWeldingWPQ";
import ViewDetailsISOWeldLog from "./components/Home/ManageProject/AddNewInspection/ViewDetailsISOWeldLog";
import ViewDetailsProjectReport from "./components/Home/ManageProject/AddNewInspection/ViewDetailsProjectReport";
import DescriptionMaster from "./components/Home/Master/DescriptionMaster/DescriptionMaster";
import SizeMaster from "./components/Home/Master/SizeMaster/SizeMaster";
import EndsMaster from "./components/Home/Master/EndsMaster/EndsMaster";
import TypeMaster from "./components/Home/Master/TypeMaster/TypeMaster";
import SurfaceMaster from "./components/Home/Master/SurfaceMaster/SurfaceMaster";
import WeldingMaster from "./components/Home/Master/WeldingMaster/WeldingMaster";
import InspectionLocMaster from "./components/Home/Master/InspectionLocMaster/InspectionLocMaster";
import ManufacturerMaster from "./components/Home/Master/ManufacturerMaster/ManufacturerMaster";
import AddDescriptionMaster from "./components/Home/Master/DescriptionMaster/AddDescriptionMaster";
import AddSizeMaster from "./components/Home/Master/SizeMaster/AddSizeMaster";
import AddEndsMaster from "./components/Home/Master/EndsMaster/AddEndsMaster";
import AddTypeMaster from "./components/Home/Master/TypeMaster/AddTypeMaster";
import AddSurfaceMaster from "./components/Home/Master/SurfaceMaster/AddSurfaceMaster";
import AddWeldingMaster from "./components/Home/Master/WeldingMaster/AddWeldingMaster";
import AddInspectionLocMaster from "./components/Home/Master/InspectionLocMaster/AddInspectionLocMaster";
import AddManufacturerMaster from "./components/Home/Master/ManufacturerMaster/AddManufacturerMaster";
import ViewDetailsNcrReport from "./components/Home/ManageProject/AddNewInspection/ViewDetailsNcrReport";
import DataVerificationTable from "./components/Home/DataVerification/DataVerificationTable";
import GlobalSeach from "./components/Home/GlobalSearch/GlobalSeach";


const App = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable={true}
        pauseOnHover={true}
        theme="light"
      />
      <BrowserRouter>
        <Routes>
        <Route
          path={LOGIN}
          element={
            <PublicRoutes>
              <Login />
            </PublicRoutes>
          }
        />
        <Route
          path={FORGOT_PASSWORD}
          element={
            <PublicRoutes>
              <ForgetPassword />
            </PublicRoutes>
          }
        />
        <Route
          path={CHANGE_PASSWORD}
          element={
            <PublicRoutes>
              <ChangePassword />
            </PublicRoutes>
          }
        />
        <Route
          path={RESET_LINK}
          element={
            <PublicRoutes>
              <ResetLink />
            </PublicRoutes>
          }
        />
        <Route
          path={DASHBOARD}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={DATA_VERIFICATION}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <DataVerificationTable />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADMIN_PROFILE}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AdminProfile />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={MANAGE_INSPECTOR}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ManageInspector />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={MANAGE_PROJECT}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ManageProject />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={NOTIFICATION}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <Notification />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_INSPECTOR}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddInspector />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${VIEW_INSPECTOR_DETAILS}/:inspectorId`}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewInspectorDetails />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${EDIT_INSPECTOR_DETAILS}/:inspectorId`}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <EditInspector />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_PROJECT}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddProject />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${VIEW_MANAGE_PROJECT_DETAILS}/:projectId`}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewManageProjectDetails />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${EDIT_MANAGE_PROJECT_DETAILS}/:projectId`}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <EditManageProject />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_NEW_INSPECTION}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsNewInspection />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={WELDING_GAS_INSPECTION_FORM}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsWeldingGas />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={WELDING_MACHINE_CALIBRATION}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsWeldMachineCalibration />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={WELDING_WPQ_INSPECTION}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsWeldingWPQ />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ISO_WELD_LOG}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsISOWeldLog />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={NCR_REPORT}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsNcrReport />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={PROJECT_REPORT}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ViewDetailsProjectReport />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={DESCRIPTION_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <DescriptionMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={SIZE_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <SizeMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ENDS_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <EndsMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={TYPE_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <TypeMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={SURFACE_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <SurfaceMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={WELDING_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <WeldingMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={INSPECTION_LOC_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <InspectionLocMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={MANUFACTURER_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <ManufacturerMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_DESCRIPTION_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddDescriptionMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_SIZE_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddSizeMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_ENDS_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddEndsMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_TYPE_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddTypeMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_SURFACE_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddSurfaceMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_WELDING_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddWeldingMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_INSPECTION_LOC_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddInspectionLocMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route
          path={ADD_MANUFACTURER_MASTER}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <AddManufacturerMaster />
              </MainLayout>
            </ProtectedRoutes>
          }
        />

        <Route
          path={GLOBAL_SEARCH}
          element={
            <ProtectedRoutes>
              <MainLayout>
                <GlobalSeach />
              </MainLayout>
            </ProtectedRoutes>
          }
        />
        <Route path="/*" element={<PageNotFoud />} />
      </Routes>
    </BrowserRouter>
    </>
  );
};

export default App;